import { render, staticRenderFns } from "./DetailsIndex.vue?vue&type=template&id=b4d5ccda&scoped=true"
import script from "./DetailsIndex.vue?vue&type=script&lang=js"
export * from "./DetailsIndex.vue?vue&type=script&lang=js"
import style0 from "./DetailsIndex.vue?vue&type=style&index=0&id=b4d5ccda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d5ccda",
  null
  
)

export default component.exports